<script setup lang="ts">
const { gridAmount = "default" } = defineProps<{
  hasMargin?: boolean;
  gridAmount?: "default" | 4 | 2;
  animation?: boolean;
}>();
</script>

<template>
  <div
    class="products-grid"
    :class="[
      `products-grid--amount-${gridAmount}`,
      { 'my-3 md:my-6': hasMargin },
    ]"
  >
    <slot />
  </div>
</template>

<style scoped lang="postcss">
.products-grid {
  @apply grid grid-cols-2 auto-rows-fr;
  @apply gap-y-4 md:gap-y-8;
  @apply gap-x-1;

  &--amount-default {
    @apply grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 5xl:grid-cols-5;
  }

  &--amount-4 {
    @apply grid-cols-4;
  }

  &--amount-2 {
    @apply grid-cols-2;
  }

  :deep(.product-card__link-container) {
    @apply w-full;
  }
}

.products-grid > * {
  @apply px-0 min-h-10 w-full;
}
</style>
